import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <>
      <Navbar />

      {/* Hero */}
<section className="policy-hero">

    <h1>Privacy Policy</h1>

</section>

      {/* Content */}
      <section className="legal-content">
        <div className="legal-container">

          <h2>1. Introduction</h2>

          <p>
            E-Forum Systems Private Limited ("we", "us", or "our") is a
            privately held, domestic and export-oriented software development
            company in Nagpur, Maharashtra with its registered office at
            Flat No 201, Shri Sai Appt, 43, Shilpa Soc, Somalwada,
            Nagpur-440015.
          </p>

          <p>
            This Privacy Policy explains how we collect, use, disclose and
            protect personal data when you use our platform, website
            (www.eforumsystems.com), or related services
            (collectively, the "Platform").
          </p>

          <p>
            This Policy is prepared in compliance with the Information
            Technology Act, 2000 ("IT Act"), the Information Technology
            (Reasonable Security Practices and Procedures and Sensitive
            Personal Data or Information) Rules, 2011 ("SPDI Rules"), and
            applicable provisions of the Digital Personal Data Protection
            Act, 2023 ("DPDP Act").
          </p>

          <h2>2. Data We Collect</h2>

          <h3>2.1 Customer Data</h3>

          <ul>
            <li>Name, mobile number and email address (registration and order placement)</li>
            <li>Delivery address and location data</li>
            <li>Order history and delivery preferences</li>
            <li>Payment transaction metadata (reference numbers, timestamps, status)</li>
            <li>Device identifiers and app usage data</li>
          </ul>

          <h3>2.2 Merchant Partner Data</h3>

          <ul>
            <li>Business name, GSTIN, proprietor/authorised contact details</li>
            <li>Pickup address and operational zone preferences</li>
            <li>Volume data, invoice references and service usage records</li>
          </ul>

          <h3>2.3 Sensitive Personal Data (SPDI)</h3>

          <p>
            We do not intentionally collect sensitive personal data as
            defined under the SPDI Rules (e.g., passwords, financial account
            details, biometric data) except as strictly necessary for
            payment processing.
          </p>

          <p>
            E-Forum Systems does not store card numbers, UPI credentials or
            net banking passwords.
          </p>

          <p>
            All payment transactions are processed via our authorised
            payment gateway partner, and such data is governed by their
            PCI-DSS-compliant infrastructure.
          </p>
                    <h2>3. Purpose of Processing</h2>

          <p>We process personal data for the following purposes:</p>

          <ul>
            <li>To register customer and merchant accounts.</li>
            <li>To facilitate order management, delivery, billing and customer support.</li>
            <li>To communicate service updates, promotional offers (where consent has been provided), and transactional notifications.</li>
            <li>To improve our products, services and user experience.</li>
            <li>To comply with legal obligations and regulatory requirements.</li>
            <li>To detect, investigate and prevent fraud, misuse and cybersecurity threats.</li>
          </ul>

          <h2>4. Lawful Basis for Processing</h2>

          <p>We process personal data on one or more of the following lawful bases:</p>

          <ul>
            <li>Consent of the data principal.</li>
            <li>Performance of a contractual obligation.</li>
            <li>Compliance with legal obligations.</li>
            <li>Legitimate business interests, provided such interests do not override the rights of the data principal.</li>
          </ul>

          <h2>5. Cookies and Tracking Technologies</h2>

          <p>
            Our Platform may use cookies, device identifiers and analytics
            tools to improve user experience, remember preferences and
            understand website traffic.
          </p>

          <p>
            Users may disable cookies through browser settings, although
            certain Platform functionalities may become unavailable.
          </p>

          <h2>6. Data Sharing and Disclosure</h2>

          <p>
            We do not sell or rent personal information.
            Personal data may be shared only with:
          </p>

          <ul>
            <li>Payment gateway providers.</li>
            <li>Cloud hosting and infrastructure providers.</li>
            <li>Government authorities where required by law.</li>
            <li>Professional advisors, auditors or legal consultants.</li>
            <li>Service providers acting under contractual confidentiality obligations.</li>
          </ul>

          <p>
            All third parties receiving personal data are required to
            maintain reasonable security safeguards.
          </p>
                    <h2>7. Data Security</h2>

          <p>
            We implement reasonable security practices and procedures,
            including administrative, technical and physical safeguards,
            to protect personal information against unauthorized access,
            disclosure, alteration or destruction.
          </p>

          <p>
            While we strive to protect your information, no transmission
            over the Internet or electronic storage system is completely
            secure. Therefore, we cannot guarantee absolute security.
          </p>

          <h2>8. Data Retention</h2>

          <p>
            Personal data is retained only for as long as necessary to
            fulfil the purposes for which it was collected, comply with
            legal obligations, resolve disputes and enforce our agreements.
          </p>

          <h2>9. Rights of Data Principals</h2>

          <p>
            Subject to applicable law, users may have the right to:
          </p>

          <ul>
            <li>Access their personal data.</li>
            <li>Request correction or updating of inaccurate information.</li>
            <li>Request deletion of personal data where legally permissible.</li>
            <li>Withdraw consent, where processing is based on consent.</li>
            <li>Lodge a grievance regarding data processing practices.</li>
          </ul>

          <h2>10. Changes to this Privacy Policy</h2>

          <p>
            We reserve the right to amend or update this Privacy Policy
            from time to time to reflect changes in legal requirements,
            technology or our business practices.
          </p>

          <p>
            The updated version shall be published on our Platform with
            the revised effective date.
          </p>

          <h2>11. Contact Information</h2>

          <p>
            If you have any questions or concerns regarding this Privacy
            Policy or our data processing practices, please contact us:
          </p>

          <ul>
            <li><strong>Company:</strong> E-Forum Systems Private Limited</li>
            <li><strong>Email:</strong> info@eforumsystems.com</li>
            <li><strong>Phone:</strong> +91 8459705239</li>
            <li><strong>Address:</strong> Pune, Maharashtra, India</li>
          </ul>

        </div>
      </section>

      <Footer />
    </>
  );
}